module.exports = __webpack_public_path__ + "static/media/country_bh.4bd2af87.webp";